import { Office365EmailLinkedService } from 'shell-models-lib';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(Office365EmailLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class Office365EmailLinkedServiceAdapter extends LinkedServiceAdapter<Office365EmailLinkedService> {

    protected modelConstructor(): new () => Office365EmailLinkedService {
        return Office365EmailLinkedService;
    }

    protected model(): IModel {
        return Office365EmailLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: Office365EmailLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: Office365EmailLinkedService): Promise<Office365EmailLinkedService> {
        return linkedService;
    }
}
